/* =========================================================
   Hero Banner New — slider controller
   Manual navigation only (no autoplay): touch/mouse swipe +
   left/right arrow buttons. Works independently per section
   instance so multiple hero sliders on one page don't conflict.
   ========================================================= */
(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('.gow-herobanner__track');
    var slides = root.querySelectorAll('.gow-herobanner__slide');
    if (!track || slides.length < 2) return; // nothing to slide

    var prevBtn = root.querySelector('.gow-herobanner__nav--prev');
    var nextBtn = root.querySelector('.gow-herobanner__nav--next');
    var count = slides.length;
    var index = 0;
    var startX = 0;
    var currentX = 0;
    var dragging = false;
    var pointerId = null;

    function render(withTransition) {
      track.style.transition = withTransition === false ? 'none' : '';
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      for (var i = 0; i < slides.length; i++) {
        var isActive = i === index;
        slides[i].classList.toggle('is-active', isActive);
        if (isActive) {
          slides[i].removeAttribute('aria-hidden');
        } else {
          slides[i].setAttribute('aria-hidden', 'true');
        }
      }
    }

    function goTo(newIndex) {
      index = ((newIndex % count) + count) % count; // wrap both directions
      render();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    /* ---------- swipe (touch + pointer/mouse drag) ---------- */
    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      startX = e.clientX;
      currentX = startX;
      track.style.transition = 'none';
      if (track.setPointerCapture) {
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      currentX = e.clientX;
      var deltaPx = currentX - startX;
      var deltaPercent = (deltaPx / root.clientWidth) * 100;
      track.style.transform = 'translateX(calc(-' + index * 100 + '% + ' + deltaPx + 'px))';
      // prevent vertical page scroll from also triggering while clearly swiping horizontally
      if (Math.abs(deltaPercent) > 4) e.preventDefault();
    }

    function onPointerUp(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      var deltaPx = currentX - startX;
      var threshold = root.clientWidth * 0.12; // ~12% of width to trigger a slide change
      track.style.transition = '';
      if (deltaPx <= -threshold) {
        next();
      } else if (deltaPx >= threshold) {
        prev();
      } else {
        render(); // snap back to current slide
      }
      startX = 0;
      currentX = 0;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', function (e) {
      if (dragging) onPointerUp(e);
    });

    /* ---------- keyboard arrow keys when the slider has focus ---------- */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); }
      else if (e.key === 'ArrowRight') { next(); }
    });

    render(false);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-hero-slider]');
    for (var i = 0; i < roots.length; i++) initSlider(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
